module.exports={"(optional)":"(volitelně)","(required)":"(požadováno)"};